import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.timeline';

/**
 * Module Init — markup
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((root) => {
    try {
      root.querySelector('script')?.remove();

      const { data } = dJSON.parse(root.data);
      if (!Array.isArray(data) || !data.length) return;

      const navList = root.querySelector('.timeline__nav .splide__list');
      const mainList = root.querySelector('.timeline__main .splide__list');
      if (!navList || !mainList) return;

      data.forEach((item, index) => {
        const card = /* html */ `
          <div class="timeline__card-area">
            <div class="timeline__connector"></div>
            <div class="timeline__card">
              <span class="timeline__card-title">${item.title || ''}</span>
            </div>
          </div>`;
        const spacer = '<div class="timeline__spacer"></div>';
        const isOdd = index % 2 === 0;

        navList.insertAdjacentHTML('beforeend', /* html */ `
          <li class="splide__slide timeline__col">
            ${isOdd ? card : spacer}
            <div class="timeline__marker">
              <div class="timeline__line"></div>
              <div class="timeline__year">${item.year || ''}</div>
            </div>
            ${isOdd ? spacer : card}
          </li>
        `);

        mainList.insertAdjacentHTML('beforeend', /* html */ `
          <li class="splide__slide timeline__detail">
            ${item.image ? `<div class="timeline__detail-media">
              <img src="${item.image}" alt="${item.title || ''}" loading="lazy">
            </div>` : ''}
            <div class="timeline__detail-content">
              ${item.date ? `<p class="timeline__detail-date">${item.date}</p>` : ''}
              ${item.title ? `<h3 class="timeline__detail-title">${item.title}</h3>` : ''}
              ${item.description ? `<p class="timeline__detail-desc">${item.description}</p>` : ''}
            </div>
          </li>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * Module Init — Splide sync
 */
(() => {
  document.querySelectorAll(moduleSelector).forEach((root) => {
    const navEl = root.querySelector('.timeline__nav');
    const mainEl = root.querySelector('.timeline__main');
    if (!navEl || !mainEl) return;

    const slideCount = navEl.querySelectorAll('.splide__slide').length;
    if (!slideCount) return;

    const main = new Splide(mainEl, {
      type: 'fade',
      rewind: true,
      perPage: 1,
      pagination: false,
      arrows: true,
    });

    const nav = new Splide(navEl, {
      type: 'slide',
      rewind: true,
      perPage: 6,
      perMove: 1,
      gap: 0,
      pagination: false,
      arrows: slideCount > 6,
      drag: slideCount > 6,
      isNavigation: true,
      trimSpace: true,
      breakpoints: {
        1500: {
          perPage: 5,
          arrows: slideCount > 5,
          drag: slideCount > 5,
        },
        1200: {
          perPage: 4,
          arrows: slideCount > 4,
          drag: slideCount > 4,
        },
        991: {
          perPage: 3,
          arrows: slideCount > 3,
          drag: slideCount > 3,
        },
        768: {
          perPage: 2,
          arrows: slideCount > 2,
          drag: slideCount > 2,
        },
        576: {
          perPage: 1,
          arrows: slideCount > 1,
          drag: slideCount > 1,
        },
      },
    });

    main.sync(nav);
    main.mount();
    nav.mount();

    // Equalize card-area and spacer heights so the marker line stays
    // at a consistent vertical centre across all slides, even when
    // card titles wrap to multiple lines. Runs after mount so Splide
    // has set final slide widths and text has reflowed.
    const cardAreas = root.querySelectorAll('.timeline__card-area');
    let maxH = 0;
    cardAreas.forEach((el) => {
      el.style.height = '';
      if (el.scrollHeight > maxH) maxH = el.scrollHeight;
    });
    cardAreas.forEach((el) => {
      el.style.height = `${maxH}px`;
    });
    root.querySelectorAll('.timeline__spacer').forEach((el) => {
      el.style.height = `${maxH}px`;
    });
  });
})();
